<template>
  <div class="Quality">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/about_slide01.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide02.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide03.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide04.jpg') center center / cover;"
        ></div>
      </agile>
      <div class="slidetextbg"></div>
      <div class="slidetext tablet-offset">{{$t('body.about_slide')}}</div>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/about_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
      <div class="container" style="position:absolute;top:0;right:0;">
        <agile
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:500px;overflow:hidden;"
          @beforeChange="syncslide"
        >
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_vision.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_trust.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_persist.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_determin.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>

    <div class="mobile-unpad">
      <div
        class="container mobile-padding mobile-bg-blue"
        style="text-align:left;padding-top:40px;margin-bottom:16px;"
      >
        <span class="title-size">{{$t('body.aboutus_quality_title')}}</span>
        <div class="subtitlebodyblue" style="margin-bottom:30px;">{{$t('body.aboutus_quality_p1')}}</div>
        <div class="subtitlebodyblue">{{$t('body.aboutus_quality_p2')}}</div>
      </div>
      <div
        class="container mobile-hide"
        style="
        background: url('./img/quality_mark.jpg') center center / contain;
        width: inherit;
        height: 300px;
        background-repeat: no-repeat;
      "
      ></div>
      <div
        class="container mobile-show"
        style="
        background: url('./img/quality_mark2.jpg') center center / contain;
        width: inherit;
        height: 250px;
        background-repeat: no-repeat;
      "
      ></div>
    </div>
    <div style="position:relative;top:170px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
export default {
  name: "quality",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    }
  }
};
</script>

<style scoped lang="scss">
.slide {
  width: 100%;
  height: 400px;
  // background: url("../assets/logo.png");
}

.column {
  padding: 0;
}

.slidetextbg {
  width: 500px;
  height: 400px;
  background: linear-gradient(to right, #013d57dd 70%, #013d5700);
  mix-blend-mode: multiply;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: justify;
  padding: 24px 200px 0 24px;
  font-size: 20px;
}

.slidetext {
  width: 550px;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: left;
  line-height: 29px;
  padding: 24px 200px 0 24px;
  font-size: 25px;
}
.slide-overlay {
  width: calc(1000px - 126px);
  height: inherit;
  font-size: 40px;
  line-height: 1;
  text-align: right;
  color: white;
  border-right: white solid 1px;
  position: relative;
  padding: 0 8px;
  top: 24px;
  // right: -500px;
}

.slide-overlay::after {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-right: 4px;
  top: 0;
  right: 0;
}
@media screen and (min-width: 768px) {
  .tablet-offset{
    top:30px;
  }
}
@media screen and (min-width: 992px) {
  .tablet-offset{
    top:0px;
  }
}
</style>